import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getAllLocations = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/locations");
  return data;
});

export const getLocation = catchAsync(async (id, xTranslate = false) => {
  const { data } = await axiosInstance.get(`salon/locations/${id}`, {
    headers: {
      "x-translations": xTranslate,
    },
  });
  return data;
});

export const getLocationLink = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`client/salons/${id}`);
  return data;
});

export const getLocationReviews = catchAsync(async (locationId, params) => {
  const { data } = await axiosInstance.get(
    `salon/locations/${locationId}/ratings`,
    {
      params,
    }
  );
  return data;
});

export const updateLocationLink = catchAsync(async (id, body) => {
  const data = await axiosInstance.post(
    `salon/locations/${id}/update-link`,
    body
  );
  return data;
});
